module.exports = __webpack_public_path__ + "img/04-K ACADEMY.jpg";